import snakeCase from 'lodash.snakecase'
import { useMemo } from 'react'
import { type IntlShape, useIntl } from 'react-intl'
import type { i18n } from 'yup-intl-validator'
import type { TMessageID } from '@/locales/types'

type IIntlShapeRichBase = i18n.IIntlShapeRich<string>

// ///////////////////////
// MARK: TYPES
export interface IIntlShapeRich extends IIntlShapeRichBase {
  formatClazz: (clazz: string) => string
  formatMessageTyped: (
    descriptor: Parameters<IntlShape['formatMessage']>[0] & {
      id: TMessageID
    },
    values?: Parameters<IntlShape['formatMessage']>[1],
    opts?: Parameters<IntlShape['formatMessage']>[2],
  ) => string
  formatMessageUntyped: IntlShape['formatMessage']
}

// ///////////////////////
// MARK: EXPORTS
export function useIntlRich(): IIntlShapeRich {
  const intl = useIntl()

  return useMemo<IIntlShapeRich>(
    () => ({
      ...intl,
      // @ts-expect-error
      formatMessageTyped(...args) {
        return intl.formatMessage(...args)
      },
      // @ts-expect-error
      formatMessageUntyped(...args) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        return intl.formatMessage(...args)
      },
      formatClazz(clazz) {
        return intl.formatMessage({
          id: `lang.${snakeCase(clazz)}`,
          defaultMessage: clazz,
        })
      },
      // @ts-expect-error
      formatErrorMessage(descriptor, ...args) {
        return intl.formatMessage(
          // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
          {
            ...descriptor,
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            defaultMessage:
              descriptor.defaultMessage ??
              this.formatMessage({
                id: 'e.unknown',
              }),
          },
          // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
          ...args,
        )
      },
    }),
    [intl],
  )
}
